export default __webpack_public_path__ + "static/media/qna-search.2e6cb02a.svg";